export const environment = {
    strictMode: false,
    apiURL: __API_BASE_URL__ + "/rest", //"https://qnet.teamqualityservices.com/rest",
    baseUrl: __API_BASE_URL__ + "/dashboard", //"https://qnet.teamqualityservices.com/dashboard",
    environment: __APP_ENV__,
    production: __APP_ENV__ === 'production',
    customerDashboardUrl: __API_BASE_URL__ + "/customer-reports", //"https://qnet.teamqualityservices.com/customer-reports",
    ordersUrl: "https://teamqualityservices.com/location-search/"
};